import React from 'react';
import {
  CoderListItem,
  CoderListItemProps
} from '../coder-list-item/coder-list-item';
import './coder-list-section.scss';

export interface CoderListSectionProps {
  title: string;
  coders: CoderListItemProps[];
  total?: number;
  isFiltered?: boolean;
}

export const CoderListSection: React.FC<CoderListSectionProps> = ({
  title,
  coders,
  total,
  isFiltered = false
}) => {
  const count = isFiltered
    ? `${coders.length} of ${total ?? coders.length} coders`
    : `${coders.length} coders`;

  return (
    <div className="cmx-coder-list-section">
      <h4 className="cmx-coder-list-section__heading">
        {title} ({count})
      </h4>
      {isFiltered && coders.length === 0 ? (
        <p className="cmx-coder-list-section__empty">No coders match</p>
      ) : (
        <div className="cmx-coder-list-section__list">
          {coders.map((coder, index) => (
            <CoderListItem key={`${coder.coderName}-${index}`} {...coder} />
          ))}
        </div>
      )}
    </div>
  );
};

CoderListSection.displayName = 'CoderListSection';
